export default __webpack_public_path__ + "static/media/is.2e5d2337.svg";